import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

export const getProducts = (params = {}) =>
  api.get('/products', { params }).then((r) => r.data);

export const getProduct = (slug) =>
  api.get(`/products/${slug}`).then((r) => r.data);

export const getCategories = () =>
  api.get('/categories').then((r) => r.data);

export const getNews = () => api.get('/news').then((r) => r.data);

export const createOrder = (payload) =>
  api.post('/orders', payload).then((r) => r.data);

export const getOrder = (orderId) =>
  api.get(`/orders/${orderId}`).then((r) => r.data);

export const sendContact = (payload) =>
  api.post('/contact', payload).then((r) => r.data);

// Stripe checkout
export const createStripeCheckout = (payload) =>
  api.post('/checkout/stripe', payload).then((r) => r.data);

export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);

export const createPaypalCheckout = (payload) =>
  api.post('/checkout/paypal', payload).then((r) => r.data);

export const confirmPaypalReturn = (orderId) =>
  api.post(`/checkout/paypal/return/${orderId}`).then((r) => r.data);

// Site settings (public — includes the maintenance-mode flag)
export const getSettings = () =>
  api.get('/settings').then((r) => r.data);
